import cookie from "js-cookie";
import * as types from "./actionTypes";

const initialState = {
  isLoading: false,
  isSuccess: false,
  payload: {},
  error: null
};

export default function userProfileReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_PROFILE_LOADING:
      return {
        ...state,
        isLoading: true
      };
    case types.GET_PROFILE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccess: true,
        error: null,
        payload: action.payload
        // payload: JSON.parse(cookie.get("user_profile"))
      };
    case types.GET_PROFILE_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    default:
      return state;
  }
}
